import { isEmpty } from 'lodash';
import { PatientTO, type ClinicTO } from '../../../../lib';

export const generateTemporaryPatient = (value: any): Partial<PatientTO> => {
  const patientTO = new PatientTO();
  patientTO.id = value.id;
  patientTO.access_token = value.access_token;
  patientTO.clinicIds = value.clinics?.map((clinic: any) => clinic.id);
  patientTO.client_no = value.clinics?.length > 0 ? value.clinics : undefined;
  patientTO.dob = value.dob;
  patientTO.first_name = value.first_name;
  patientTO.last_name = value.last_name;
  return patientTO;
};

export const extractTeamOrHospitalId = (
  clinic?: ClinicTO,
): { teamId: number | null; hospitalId: number | null } => {
  if (!clinic) {
    return { teamId: null, hospitalId: null };
  }
  const [detail] =
    clinic.clinic_details && clinic.clinic_details?.length > 0
      ? clinic.clinic_details
      : [{} as Record<string, any>];
  if (isEmpty(detail)) {
    return { teamId: null, hospitalId: null };
  }

  // If unit is a team, hospital id comes from parent, team id from current clinic id
  if (detail.organisation_unit === 'team') {
    return {
      teamId: detail.id ?? clinic.clinic_id ?? null,
      hospitalId: detail.parent_clinic_id ?? null,
    };
  }

  // If unit is a hospital, use current clinic id as hospital id
  if (detail.organisation_unit === 'hospital') {
    return {
      teamId: null,
      hospitalId: detail.id ?? clinic.clinic_id ?? null,
    };
  }

  // Unknown unit: default to current clinic id as hospital id
  const fallbackId = detail.id ?? clinic.clinic_id ?? null;
  return { teamId: null, hospitalId: fallbackId };
};
